import React from 'react';
import {} from 'components/core';
import ProceduresList from './list';
import CreateDialog from './create';
import EditWizard from './editWizard';


export default function Procedures({mainDialogOpen, handleDialogClose, collapsed, handleShowPanel, setLoadedProcedure})
{
    const [editDialogState, setEditDialogState] = React.useState({open: false, procedureID: null});


    console.log(editDialogState);
    const handleRowSelected = (row) =>
    {
      handleShowPanel({procedureID: row.id});
    }

    const handleCreated = (newID) =>
    {
      handleShowPanel({procedureID: newID});
      setEditDialogState({open: true, procedureID: newID});
    }

    const handleCloseEdit = () => {
      setEditDialogState({open: false, procedureID: null});
    }

    return <>
      <CreateDialog open={mainDialogOpen} handleClose={()=>handleDialogClose()} onConfirm={(newID) => handleCreated(newID)}/>
      <EditWizard open={editDialogState.open} handleClose={()=>handleCloseEdit()} procedureID={editDialogState.procedureID}/>
      <ProceduresList onRowSelected={(row) => handleRowSelected(row)} collapsed={collapsed} handleEdit={(procedureID) => handleCreated(procedureID)} />
    </>
}

